/**
 * Path for the SSO callback route. Used by:
 * - PublicRoutes.tsx (route registration)
 * - cognitoAuth.ts (Amplify OAuth redirectSignIn)
 * - init.ts (onAuthChanged guard to prevent logout during token exchange)
 */
export const SSO_CALLBACK_PATH = "/v2/sso-callback";
